import React, {Component, Fragment} from 'react'
import {Row, Col} from 'antd';
import {DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR} from '../../utills/constants'

export default class OrderShortInfoView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {order} = this.props;
        return (
            <div className="order-info-details">
                <Row className='order-info-item'>
                    <Col span={6}>
                        <span className='label'>订单编号：</span>
                        <span>{order.orderNo}</span>
                    </Col>
                    <Col span={6}>
                        <span className='label'>揽收单位：</span>
                        <span>{order.entName}</span>
                    </Col>
                    <Col span={6}>
                        <span className='label'>起运地：</span>
                        <span>{order.originCountry} {order.originCity}</span>
                    </Col>
                    <Col span={6}>
                        <span className='label'>{order.deliveryType === 'X' ? '起始站' : '出境口岸'}：</span>
                        <span>{order.customsPortName}</span>
                    </Col>
                    {DELIVERY_TYPE_MIX.hasOwnProperty(order.deliveryType) ?
                        <Col span={6}>
                            <span
                                className='label'>{order.deliveryType === 'X' || order.deliveryType === 'D' ? '目的站' : '转关地'}：</span>
                            <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                        </Col> : null}
                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                        <Col span={6}>
                            <span className='label'>清关地：</span>
                            <span>{order.customsClearanceCountry} {order.customsClearanceCity}</span>
                        </Col> : null}
                    {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                        <Col span={6}>
                            <span className='label'>目的机场：</span>
                            <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                        </Col> : null}
                    <Col span={6}>
                        <span className='label'>目的地：</span>
                        <span>{order.destinationCountry} {order.destinationCity}</span>
                    </Col>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ? null :
                        <Col span={6}>
                            <span className='label'>还箱地：</span>
                            <span>{order.boxReturnStation}</span>
                        </Col>}
                    <Col span={6}>
                        <span className='label'>提交时间：</span>
                        <span>{order.commitDt}</span>
                    </Col>
                    <Col span={6}>
                        <span className='label'>发货时间：</span>
                        <span>{order.deliveryEstimateDt}</span>
                    </Col>
                </Row>
            </div>
        )
    }
}